import React from 'react';

import {
  I18N_AVANT_PROPERTY_COMMON_LABEL_PATH,
  I18N_PLATFORM_COMMON_WORD_PATH,
} from 'constants/i18n';
import TextInput from 'components/Inputs/TextInput';
import FormControl from 'components/FormControl';
import { ICompany } from 'interfaces/ICompany';
import { translateText } from 'utils/i18n';

import { CompanyFieldsNames } from './constants';
import formsStyles from '../FormSection.module.scss';
import Comments from '../FormFields/Comments';

interface Props {
  company: ICompany;
  onChange: (field: string, value: any) => void;
}
export const CompanyContactSection = ({ company, onChange }: Props) => {
  return (
    <>
      <FormControl
        label={translateText(`${I18N_PLATFORM_COMMON_WORD_PATH}.website`)}
        wrapperClassName={formsStyles['form-row']}
      >
        <TextInput
          borderBox
          fullWidth
          id="company-website-field"
          onChange={value => onChange(CompanyFieldsNames.WEBSITE, value)}
          placeholder={translateText(
            `${I18N_AVANT_PROPERTY_COMMON_LABEL_PATH}.enterCompanyWebsite`,
          )}
          value={company.website}
        />
      </FormControl>

      <FormControl
        label={translateText(`${I18N_PLATFORM_COMMON_WORD_PATH}.linkedIn`)}
        wrapperClassName={formsStyles['form-row']}
      >
        <TextInput
          borderBox
          fullWidth
          id="company-linkedIn-field"
          onChange={value => onChange(CompanyFieldsNames.LINKEDIN, value)}
          placeholder={translateText(
            `${I18N_AVANT_PROPERTY_COMMON_LABEL_PATH}.enterCompanyLinkedIn`,
          )}
          value={company.linkedIn}
        />
      </FormControl>

      <FormControl
        label={translateText(`${I18N_PLATFORM_COMMON_WORD_PATH}.emailDomain`)}
        wrapperClassName={formsStyles['form-row']}
      >
        <TextInput
          borderBox
          fullWidth
          id="company-domain-field"
          onChange={value => onChange(CompanyFieldsNames.DOMAIN, value)}
          placeholder={translateText(
            `${I18N_PLATFORM_COMMON_WORD_PATH}.atDomain`,
          )}
          value={company.domain}
        />
      </FormControl>

      <FormControl
        label={translateText(`${I18N_PLATFORM_COMMON_WORD_PATH}.stockTicker`)}
        wrapperClassName={formsStyles['form-row']}
      >
        <TextInput
          borderBox
          fullWidth
          id="company-stockCode-field"
          onChange={value => onChange(CompanyFieldsNames.STOCK_CODE, value)}
          placeholder={translateText(
            `${I18N_PLATFORM_COMMON_WORD_PATH}.enterStockTicker`,
          )}
          value={company.stockCode}
        />
      </FormControl>
      <Comments
        field="comments"
        onChange={onChange}
        value={company?.comments}
        label={translateText(
          'avantPlatform.attributes.property.label.descriptionComment',
        )}
      />
    </>
  );
};
